import createEntry from 'common/core/createEntry';

import WebviewApp from './WebviewApp';
import WebviewReducers from './WebviewReducers';

const GA4MeasurementID = 'G-HLZG3ZLP3C';
const SentryDSN = 'e6d8a8dde34b4fc0b45a9837990ca732';

createEntry({
  app: WebviewApp,
  ga4MeasurementID: GA4MeasurementID,
  reducers: WebviewReducers,
  sentryDSN: SentryDSN,
});
